import React, { useState, useEffect, useRef } from 'react';
import { Modal, TextField, BlockStack, Text, Icon, ResourceList, ResourceItem } from '@shopify/polaris';
import { SearchIcon } from '@shopify/polaris-icons';

import { FetchCustom } from './FetchCustom';
import { useHostNavigate } from "../hooks";

export function CustomerPickerCustom(props) {
    const navigate = useHostNavigate();
    const fetch = FetchCustom();

    const [loading, setLoading] = useState(false);
    const [list, setList] = useState({ items: [], pageInfo: {} });
    const [selectedItems, setSelectedItems] = useState(props.selectedCustomers ? props.selectedCustomers : []);
    const [redirectUrl, setRedirectUrl] = useState('');

    const typingTimer = useRef();

    const load = async (startCursor, endCursor, query) => {
        setLoading(true);

        const data = await fetch('api/home/customers', { startCursor: startCursor, endCursor: endCursor, query: query });
        if (data.redirectUrl) {
            setRedirectUrl(data.redirectUrl);
        }
        else {
            setList(data);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (props.open) {
            load(null, null, props.initialQuery);
        }
        // eslint-disable-next-line
    }, [props.open]);

    useEffect(() => {
        if (redirectUrl) {
            navigate(redirectUrl);
        }
    }, [redirectUrl, navigate]);

    return (
        <Modal
            title={props.editing ? "Edit customers" : "Add customers"}
            open={props.open}
            limitHeight={true}
            onClose={() => { props.handleCustomerPicker('open', false); }}
            primaryAction={{
                content: props.editing ? "Done" : "Add",
                onAction: () => {
                    let ids = props.initialSelectionIds.map(p => p.replace('customer_', '')).join();
                    props.handleChange('customers', ids);
                    props.handleChange('selectedCustomers', selectedItems);
                    props.handleChange('segments', null);
                    props.handleChange('selectedSegments', null);
                    props.handleChange('customerTags', null);
                    props.handleChange('selectedCustomerTags', null);
                    props.handleError('customerType', !ids);
                    props.handleCustomerPicker('open', false);
                }
            }}
            secondaryActions={[
                {
                    content: 'Cancel',
                    onAction: () => { props.handleCustomerPicker('open', false); }
                },
            ]}
        >
            <div className="customer-picker">
                <div className="modal-sticky-bar">
                    <Modal.Section>
                        <BlockStack gap="300">
                            <div><Text as="span" tone="subdued">You can create a new customer from the</Text> <a href={props.user.shopifyAdminUrl + "/customers/new"} target="_blank" rel="noreferrer" className="Polaris-Link">Customers Page</a></div>
                            <TextField
                                value={props.initialQuery}
                                focused={true}
                                placeholder={'Search customers'}
                                prefix={<Icon source={SearchIcon} tone="subdued" />}
                                onChange={(newValue) => {
                                    props.handleCustomerPicker('initialQuery', newValue);
                                    clearTimeout(typingTimer.current);
                                    typingTimer.current = setTimeout(function () {
                                        load(null, null, newValue);
                                    }, 400);
                                }}
                            />
                        </BlockStack>
                    </Modal.Section>
                </div>
                <ResourceList
                    items={list.items}
                    selectedItems={props.initialSelectionIds}
                    loading={loading}
                    emptyState={<Modal.Section>{`No results found${props.initialQuery ? ' for "' + props.initialQuery + '"' : ''}`}</Modal.Section>}
                    onSelectionChange={(newValue) => {
                        props.handleCustomerPicker('initialSelectionIds', newValue);

                        let ids = newValue.map(p => parseFloat(p.replace('customer_', '')));
                        let sItems = selectedItems.filter(p => ids.indexOf(p.id) > -1);

                        ids.forEach(id => {
                            if (!sItems.filter(p => p.id === id).length) {
                                sItems.push(list.items.filter(p => p.id === id)[0]);
                            }
                        });

                        setSelectedItems(sItems);
                    }}
                    pagination={list.pageInfo.hasPreviousPage || list.pageInfo.hasNextPage ? {
                        hasPrevious: list.pageInfo.hasPreviousPage,
                        hasNext: list.pageInfo.hasNextPage,
                        onPrevious: () => {
                            load(list.pageInfo.startCursor, null, null);
                        },
                        onNext: () => {
                            load(null, list.pageInfo.endCursor, null);
                        },
                    } : null}
                    renderItem={(item) => {
                        return (
                            <ResourceItem
                                verticalAlignment="center"
                                id={"customer_" + item.id}
                                key={item.id}
                                onClick={() => {
                                    let el = document.querySelector('.customer-picker')?.querySelector(`.Polaris-Box#customer_${item.id}`)?.querySelector('.Polaris-Checkbox__Input');
                                    if (el) {
                                        el.click();
                                    }
                                }}
                            >
                                <Text>{!item.firstName && !item.lastName ? item.email : (item.firstName + " " + item.lastName).trim()}</Text>
                                <Text tone="subdued">{item.email}</Text>
                            </ResourceItem>
                        );
                    }}
                    selectable={true}
                    showHeader={false}
                />
            </div>
        </Modal>
    );
}